<template>
    <v-flex class="m2mx-block" v-if="isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.DEFAULT_EDIT_TEXT.MEMBER_TO_MEMBER_EXCHANGE}}</v-flex>
        <v-layout row>
            <v-flex xs2>
            <img src="../../assets/m2mxLogo.png">
            </v-flex>
            <v-flex xs10 pl-4>                
                <v-flex tag="em">
                    <span data-qe-id="m2mx_update_link" target="_blank">
                        {{memberProfileConstants.DEFAULT_EDIT_TEXT.M2MX_UPDATE}}
                    </span>
                    <span class="bold-font"> 
                        {{memberProfileConstants.DEFAULT_EDIT_TEXT.M2MX_SHARE}} 
                    </span>
                </v-flex>
                 <v-btn class="primary_btn m2mx-block__btn" data-qe-id="m2mx_update_btn" @click="redirectM2mx()">
                     {{memberProfileConstants.DEFAULT_EDIT_TEXT.M2MX_UPDATE_PROFILE}}
                </v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { mapGetters, mapActions } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from '../../store/storeGetters.constant';
    import { myAccountConstants } from "../MyAccount/myaccount.constants.js";

    export default {
        name: "M2mx",
        data: () => ({
            memberProfileConstants,
            myAccountConstants,
            M2MxUrl: "",
        }),
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getResourceLinks();
        },
        methods: {
            ...mapActions({
                getResourceLinks: `tools/${storeAction.getResourceLinks}`,
            }),
        redirectM2mx() {
            if (this.isMobileAppBrowser) {                    
                    window.open(`${memberProfileConstants.DEFAULT_EDIT_TEXT.M2MX_UPDATE_PROFILE_URL}`, '_self');
                } else {
                    window.open(`${memberProfileConstants.DEFAULT_EDIT_TEXT.M2MX_UPDATE_PROFILE_URL}`, '_blank');
            }
        },
        },
        computed: {
            ...mapGetters({
                resourceLinks: `tools/${storeGetters.resourceLinks}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            isCurrentUser() {
                return this.memberId === this.$parent.currentUserId;
            },
        },
        watch: {
            resourceLinks(val) {
                if (val) {
                    val.forEach((element) => {
                        element.forEach((subElement) => {
                            if (subElement.resourceCenterCategoryName === this.myAccountConstants.My_ACCOUNT && subElement.name === this.memberProfileConstants.M2MX_NAME) {
                                this.M2MxUrl = subElement.url;
                                return true;
                            }
                        });
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

.m2mx-block {
    border-bottom: 1px solid $ypo-open-blue-gray;
    margin-bottom: 20px;
    padding: 0 20px 20px 20px;

    &__btn{
        margin-left: 0px;
    }

    span {
        font-style: normal;
        font-size: 12px;
        margin-bottom: 5px;
        line-height: 20px;  
    }
    
    em{
        display: block;
        font-style: normal;
        font-size: 12px;
        margin-bottom: 5px;
        line-height: 20px;  

        a{
            text-decoration: none;
        }
    }
    img{
        max-width: 100%;
    }

    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;


        i {
            color: $ypo-dark-background-gray;
            font-size: 14px;
            position: relative;
            left: 5px;
            margin-right: 40px;
            cursor: pointer;
        }
    }
    @media (max-width: 1199px) {
        margin-top: 30px;
        padding: 0 0 20px 0;
    }
    
}
</style>
